import { formatSecondsToTimestamp } from "@memorang/helpers/common";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type Props = {
	label: string;
	timeLeftSeconds: number;
	color?: string;
};

const ProgressTimer = ({ label, timeLeftSeconds, color }: Props) => {
	const isTimesUp = timeLeftSeconds <= 0;
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box alignItems="flex-end" gap={2}>
			{label ? (
				<Text
					style={{
						fontSize: 12,
						color: color ?? theme.colors.onSurfaceVariant,
					}}
				>
					{label}
				</Text>
			) : null}
			<Box flexDirection="row" alignItems="center" gap={4}>
				<Icon
					name="clock-outline"
					size={16}
					color={color ?? theme.colors.primary}
				/>
				<Text
					style={{
						fontSize: 16,
						color: color ?? theme.colors.onSurfaceVariant,
						fontWeight: "600",
					}}
				>
					{isTimesUp
						? t("testDriver.progressBar.timesUp")
						: formatSecondsToTimestamp(timeLeftSeconds, { padMinutes: true })}
				</Text>
			</Box>
		</Box>
	);
};

export default ProgressTimer;
